export default __webpack_public_path__ + "static/media/sandro.f42db97a.jpg";